<template>
  <div :class="['w3-row', 'definition-wrapper', 'pdf', definition.id, {'error_validate': mandatoryValidation}]">
    <transition name="fade" mode="out-in">
      <iframe v-if="pdfUrl" :src="pdfUrl" class="previewIframePdf" scrolling="no" ref="previewPdf" />
      <spinner-loading v-else class="spinner-loading" :line-size='2' :size='18' line-fg-color='#5dbecd' />
    </transition>
  </div>
</template>

<script>
import DefinitionReadOnly from './readOnly'
import DefinitionMultilanguage from './multilanguage'
import DefinitionTask from './task'
import transport from 'vue-definition-utils/src/utils/transport'
import moment from 'moment'

// https://github.com/eKoopmans/html2pdf.js
import html2pdf from 'html2pdf.js'

export default {
  name: 'definition-pdf',
  props: [
    'definition',
    'object',
    'definitionObject',
    'editable',
    'mandatoryValidation',
    'languageSelected',
    'definitionId',
    'definitionContentId',
    'repeatableGroupCode',
    'showMultilanguage',
    'requestObjectForAdd',
    'requestObjectForAddModified',
    'language',
    'authorization',
    'type',
    'visuals',
    'apiparams',
    'callTask',
    'withPdfViewer',
    'sendTmpPdf'
  ],
  components: {
    DefinitionReadOnly,
    DefinitionMultilanguage,
    DefinitionTask
  },
  data () {
    return {
      pdfHtml: null,
      pdfUrl: null,
      pdfName: null,
      translating: false
    }
  },
  beforeMount () {
    // console.log('beforeMount')
    if (this.repeatableGroupCode) {
      this.pdfName = this.repeatableGroupCode + '.pdf'
    } else {
      this.pdfName = this.definitionContentId + '.pdf'
    }
  },
  mounted () {
    // console.log('mounted')
    this.setPdfHtml(this.languageSelected)
  },
  methods: {
    setPdfHtml (languageSelected) {
      // console.log('setPdfHtml')
      if (!this.isMultiLanguage()) {
        if (this.object.textValue) {
          this.pdfHtml = this.object.textValue
        } else {
          this.pdfHtml = null
        }
      } else if (languageSelected) {
        this.setLanguagePdfHtml(languageSelected)
      }

      // is HTML or URL?
      if (this.pdfHtml) {
        // PDF from HTML
        if (this.pdfHtml.toLowerCase().includes('<!doctype html')) {
          this.getPdfTmpAndUrl()
        // PDF from file URL
        } else {
          this.pdfUrl = this.pdfHtml
          this.pdfHtml = null
        }
      }
    },
    setLanguagePdfHtml (languageSelected) {
      // console.log('setLanguagePdfHtml')
      this.pdfHtml = transport.methods.getLanguageValue(this.object, languageSelected.key)
    },
    getPdfTmpAndUrl () {
      // console.log('getPdfTmpAndUrl')
      let vm = this
      let opt = {
        margin: [15, 10, 15, 10],
        filename: this.pdfName,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
      }

      // save pdf blob and url for viewer
      html2pdf().from(this.pdfHtml).set(opt).toPdf().get('pdf').then(function (pdf) {
        vm.pdfUrl = pdf.output('bloburl')
        if (vm.sendTmpPdf) {
          vm.sendTmpFile(pdf.output('blob'))
        }
      })
    },
    sendTmpFile (file) {
      // console.log('sendTmpFile')
      var xhr = null

      xhr = new XMLHttpRequest()
      xhr.withCredentials = false
      xhr.open('POST', this.type.domainEndpoint + '/pdf')
      xhr.onload = () => {
        var data
        if (xhr.status !== 200) {
          console.error('HTTP Error: ' + xhr.status)
          return
        }
        data = JSON.parse(xhr.responseText)
        if (!data) {
          console.error('Invalid JSON: ' + xhr.responseText)
        } else {
          this.setObjectPdfTmp(data.requestResultSuccess)
        }
      }

      var formData = new FormData()
      formData.append('file', file, this.pdfName)
      xhr.setRequestHeader('Authorization', this.authorization)
      xhr.send(formData)
    },
    validateFileFormat () {
      // console.log('validateFileFormat')
      var format = null
      if (this.isMultiLanguage()) {
        format = transport.methods.getLanguage(this.languageSelected.key, this.definition).format
      } else {
        format = this.definition.validation.format
      }
      this.validation = transport.methods.validateFileFormat(this.definition, format, this.pdfHtml)
      // 3. if text format validation past...
      if (this.validation === null) {
        // ... launch refresh definition event
        this.$emit('refreshDefinition', this.object)
      } else {
        // ... or launch text format error event to show error message
        this.$emit('fileFormatError', moment().valueOf(), this.validation, format)
      }
    },
    isMultiLanguage () {
      // console.log('isMultiLanguage')
      return transport.methods.isMultiLanguage(this.definition)
    },
    setObjectPdfTmp (pdfTmp) {
      // console.log('setObjectPdfTmp')
      if (this.isMultiLanguage()) {
        this.object = transport.methods.setLanguageValue(this.object, pdfTmp, this.languageSelected.key)
      } else {
        this.object.textValue = pdfTmp
      }
    }
  },
  watch: {
    mandatoryValidation (value) {
      // 2. if mandatory validation past...
      if (value && (value.validateKey === null || value.validateKey.trim() === '')) {
        // ... launch file format validation
        this.validateFileFormat()
      }
    },
    languageSelected (languageSelected) {
      if (this.isMultiLanguage()) {
        this.setLanguagePdfHtml(languageSelected)
      }
    },
    object (object) {
      this.setPdfHtml(this.languageSelected)
    }
  }
}
</script>

<style lang="scss">
.pdf {
  &.definition-wrapper {
    display: flex;
  }
  .pdfReadOnly {
    border: 0;
    width: 100%;
    height: 390px;
    margin: 10px 0;
    background-color: #fff;
  }
  .pdfOverlay {
    position: absolute;
    top: 5px;
    bottom: 2px;
    left: 0;
    right: 0;
    cursor: pointer;
    background-color: rgba(100,100,100,0.0);
    transition: all 0.2s ease-in;
    text-align: center;

    .pdfIcon {
      position: absolute;
      bottom: 1px;
      left: 1.5px;
      right: 1.5px;
      margin: 0 auto;
      transition: all 0.2s ease-in;
      opacity: 0;
      background-color: #efefef;
      padding: 5px 0 8px;

      img {
        max-width: 25px;
      }
    }
  }
  .pdfOverlay:hover {
    background-color: rgba(100,100,100,0.6);

    .pdfIcon {
      opacity: 1;
    }
  }
}
.pdf-app {
  margin-top: 10px;

  #toolbarViewerRight {
    .verticalToolbarSeparator,
    #secondaryToolbarToggle {
      display: none;
    }
  }
}
.previewIframePdf {
  width: 100%;
  height: 740px;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/content/definitionLoader/item/pdf.vue